import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    checkedItems: [], // Lista zaznaczonych powiadomień (IDs)
    currentPage: 0, // Domyślna strona (0-indexed)
    maxPages: 1, // Domyślna maksymalna liczba stron
    sortBy: 'createdAt',
    sortDirection: 'DESC', // Domyślny kierunek sortowania
    searchQuery: null, // Wyszukiwana fraza
    searchValue: '', // Wartość wyszukiwania
    status: null, // Filtr statusu kampanii (ACTIVE, DELETED)
    type: null, // Filtr typu (SINGULAR, RECURRING)
    dateFrom: null, // Filtr daty od
    dateTo: null, // Filtr daty do
    isRecurring: null, // Filtr czy powtarzające się
    totalCount: 0, // Całkowita liczba powiadomień
    showAddModal: false,
    showEditModal: false,
    viewedNotification: null,
  },
  reducers: {
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload;
    },
    toggleCheckedItem: (state, action) => {
      const itemId = action.payload;
      const exists = state.checkedItems.includes(itemId);
      if (exists) {
        state.checkedItems = state.checkedItems.filter((id) => id !== itemId);
      } else {
        state.checkedItems.push(itemId);
      }
    },
    setPage(state, action) {
      state.checkedItems = [];
      state.currentPage = action.payload;
    },
    setMaxPages(state, action) {
      state.maxPages = action.payload;
    },
    setSorting(state, action) {
      state.checkedItems = [];
      const { sortBy, sortDirection } = action.payload;
      state.sortBy = sortBy;
      state.sortDirection = sortDirection;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
      state.currentPage = 0;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
      state.currentPage = 0;
    },
    setType(state, action) {
      state.type = action.payload;
      state.currentPage = 0;
    },
    setDateFrom(state, action) {
      state.dateFrom = action.payload;
      state.currentPage = 0;
    },
    setDateTo(state, action) {
      state.dateTo = action.payload;
      state.currentPage = 0;
    },
    setIsRecurring(state, action) {
      state.isRecurring = action.payload;
      state.currentPage = 0;
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload;
    },
    clearFilters(state) {
      state.searchQuery = null;
      state.searchValue = '';
      state.status = null;
      state.type = null;
      state.dateFrom = null;
      state.dateTo = null;
      state.isRecurring = null;
      state.currentPage = 0;
    },
    toggleAddModal(state) {
      state.showAddModal = !state.showAddModal;
    },
    toggleEditModal(state) {
      state.showEditModal = !state.showEditModal;
    },
    setShowAddModal(state, action) {
      state.showAddModal = action.payload;
    },
    setShowEditModal(state, action) {
      state.showEditModal = action.payload;
    },
    setViewedNotification(state, action) {
      state.viewedNotification = action.payload;
    },
    toggleNeedRefresh(state) {
      // Trigger refresh by toggling a flag or incrementing a counter
      state.currentPage = state.currentPage; // This will trigger useEffect
    },
  },
});

export const {
  setCheckedItems,
  toggleCheckedItem,
  setPage,
  setMaxPages,
  setSorting,
  setSearchQuery,
  setSearchValue,
  setStatus,
  setType,
  setDateFrom,
  setDateTo,
  setIsRecurring,
  setTotalCount,
  clearFilters,
  toggleAddModal,
  toggleEditModal,
  setShowAddModal,
  setShowEditModal,
  setViewedNotification,
  toggleNeedRefresh,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;

